import React, {Fragment} from 'react';
import {Outlet} from 'react-router-dom';
import {RequireAuth} from '../components/AuthComponents';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Menu from '../components/Menu';

import './CSS/Layout.css';

const Layout: React.FC = () => {
    return (
        <div id='Layout'>
            <div className='SW-update-dialog'></div>
            <Header></Header>
            <div className='container'>
                <RequireAuth>
                    <Fragment>
                        <Menu></Menu>
                        <div id='content'>
                            <Outlet />
                        </div>
                    </Fragment>
                </RequireAuth>
            </div>
            <Footer></Footer>
        </div>
    );
};

export default Layout;
